import { PlayerEvent } from "../../events/PlayerEvent.js";
import { PlayerEventAction, PlayerEventsSource } from "../../player/Player.js";


export interface MapperConfigFlags {

    media?: boolean,
    media_progress?: boolean,
    aderrors?: boolean,
    adevents?: boolean

}


export abstract class CommonEventMapper implements AttachableEventMapper {


    private currentSource: PlayerEventsSource;
    private currentListener: PlayerEventAction;


    constructor() {
        this.currentListener = null;
        this.currentSource = null;
    }
    

    public attachEventSource(evtsrc: PlayerEventsSource): void {
        if(this.currentSource && this.currentListener) {
            this.currentSource.offPlayerEvent(this.currentListener);
        }
        this.currentSource = evtsrc;
        this.currentListener = evtsrc.onPlayerEvent((evt) => this.reactToEvents(evt));
    }


    protected abstract reactToEvents(evt: PlayerEvent): void;
}



export interface AttachableEventMapper {
    attachEventSource(evtsrc: PlayerEventsSource): void;
}